module.exports = __webpack_public_path__ + "static/media/34DSS3.5a6b9876.jpg";